import { NgModule } from '@angular/core';
import { RecommendedListsCardComponent } from './recommended-lists-card.component';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MatExpansionModule } from '@angular/material/expansion';

@NgModule({
  imports: [CommonModule, RouterLink, MatExpansionModule],
  declarations: [RecommendedListsCardComponent],
  exports: [RecommendedListsCardComponent],
})
export class RecommendedListsCardModule {}
